<div class="flex flex-row flex-wrap w-full h-full">
  <div class="w-full sm:w-[33%] flex justify-start">
    <mat-icon class="large-icon" (click)="back()"
    title="{{ 'gamePlayList.back' | transloco }}">arrow_circle_left</mat-icon>
  </div>
  <div class="w-full sm:w-[33%] flex justify-center">
    <span class="entete">{{ 'gamePlayList.title' | transloco }}</span>
  </div>
  @if (this.game.game.gameStatus === GameStatus.InReview) {
    <div class="w-full sm:w-[33%] flex justify-end icon-xs-spacing">
      @if (showSendHudlIcon) {
        <mat-icon class="large-icon " (click)="sendHudlDocByEmail()"
        title="{{ 'gamePlayList.csv' | transloco }}" >dvr</mat-icon>
      }
      <mat-icon class="large-icon" (click)="generateStatsPDF()"
      title="{{ 'gamePlayList.generateStats' | transloco }}" >123</mat-icon>
      @if (showSendStatsIcon) {
        <mat-icon  class="large-icon" (click)="sendStatsByEmail()"
        title="{{ 'gamePlayList.email' | transloco }}" >mail</mat-icon>
      }
    </div>
  }
</div>

<app-button-toggle-group>
  <mat-button-toggle-group aria-label="Filter">
    <mat-button-toggle data-testid="qtrAll" [checked]="qtrFilter === undefined" (click)="selectQuarter(undefined)">{{ 'gamePlayList.qtrAll' | transloco }}</mat-button-toggle>
    <mat-button-toggle data-testid="qtr1" [checked]="qtrFilter === 1" (click)="selectQuarter(1)">{{ 'gamePlayList.qtr1' | transloco }}</mat-button-toggle>
    <mat-button-toggle data-testid="qtr2" [checked]="qtrFilter === 2" (click)="selectQuarter(2)">{{ 'gamePlayList.qtr2' | transloco }}</mat-button-toggle>
    <mat-button-toggle data-testid="qtr3" [checked]="qtrFilter === 3" (click)="selectQuarter(3)">{{ 'gamePlayList.qtr3' | transloco }}</mat-button-toggle>
    <mat-button-toggle data-testid="qtr4" [checked]="qtrFilter === 4" (click)="selectQuarter(4)">{{ 'gamePlayList.qtr4' | transloco }}</mat-button-toggle>
    <mat-button-toggle data-testid="qtr5" [checked]="qtrFilter === 5" (click)="selectQuarter(5)">{{ 'gamePlayList.qtr5' | transloco }}</mat-button-toggle>
  </mat-button-toggle-group>
</app-button-toggle-group>

<div>
  @if (!editedGamePlay) {
    <section class="liste">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>#</th>
            <th><div class="th"><div class="vertical">odk</div></div></th>
            <th><div class="th"><div class="vertical">down</div></div></th>
            <th><div class="th"><div class="vertical">distance</div></div></th>
            <th><div class="th"><div class="vertical">yardLine</div></div></th>
            <th><div class="th"><div class="vertical">hash</div></div></th>
            <th><div class="th"><div class="vertical">playType</div></div></th>
            <th><div class="th"><div class="vertical">result</div></div></th>
            <th><div class="th"><div class="vertical">gnLs</div></div></th>
            <th><div class="th"><div class="vertical">penYards</div></div></th>
            <th><div class="th"><div class="vertical">penaltyOn</div></div></th>
            <th><div class="th"><div class="vertical">kick Yards</div></div></th>
            <th><div class="th"><div class="vertical">return Yards</div></div></th>
            <th><div class="th"><div class="vertical">rusher</div></div></th>
            <th><div class="th"><div class="vertical">opp Rusher</div></div></th>
            <th><div class="th"><div class="vertical">passer</div></div></th>
            <th><div class="th"><div class="vertical">opp Passer</div></div></th>
            <th><div class="th"><div class="vertical">receiver</div></div></th>
            <th><div class="th"><div class="vertical">opp Receiver</div></div></th>
            <th><div class="th"><div class="vertical">tackler 1</div></div></th>
            <th><div class="th"><div class="vertical">opp Tackler 1</div></div></th>
            <th><div class="th"><div class="vertical">tackler 2</div></div></th>
            <th><div class="th"><div class="vertical">opp Tackler 2</div></div></th>
            <th><div class="th"><div class="vertical">batted Down</div></div></th>
            <th><div class="th"><div class="vertical">opp Batted Down</div></div></th>
            <th><div class="th"><div class="vertical">FF by</div></div></th>
            <th><div class="th"><div class="vertical">opp FF By</div></div></th>
            <th><div class="th"><div class="vertical">Returner</div></div></th>
            <th><div class="th"><div class="vertical">opp Returner</div></div></th>
            <th><div class="th"><div class="vertical">kicker</div></div></th>
            <th><div class="th"><div class="vertical">opp Kicker</div></div></th>
            <th><div class="th"><div class="vertical">recovered By</div></div></th>
            <th><div class="th"><div class="vertical">opp Recovered By</div></div></th>
            <th><div class="th"><div class="vertical">intercepted By</div></div></th>
            <th><div class="th"><div class="vertical">opp Intercepted By</div></div></th>
          </tr>
        </thead>
        <tbody>
          @for (gamePlay of getPlayList(); track gamePlay; let first = $first) {
            <tr>
              <td>
                <button mat-icon-button
                  data-testid="editGamePlay"
                  aria-label="Edit GamePlay"
                  routerLink="/game-play-list/{{ gamePlay.gamePlayNumber }}"
                  [disabled]="first && this.game.game.gameStatus !== GameStatus.InReview && qtrFilter === undefined || gamePlay._status === GameStatus.Pending"
                  >
                  <!-- (click)="editGamePlay(gamePlay)" -->
                  <mat-icon>edit</mat-icon>
                </button>
                @if (this.game.game.gameStatus === GameStatus.InReview) {
                  <button
                    mat-icon-button
                    data-testid="addGamePlay"
                    aria-label="Add GamePlay"
                    (click)="addGamePlay(gamePlay?.gamePlayNumber ?? 0)"
                    [disabled]="first && this.game.game.gameStatus !== GameStatus.InReview && qtrFilter === undefined || gamePlay._status === GameStatus.Pending"
                    >
                    <mat-icon>add</mat-icon>
                  </button>
                }
              </td>
              <td class="game-number">{{ gamePlay.gamePlayNumber }}</td>
              <td>{{ gamePlay.odk }}</td>
              <td>{{ gamePlay.down }}</td>
              <td>{{ gamePlay.distance }}</td>
              <td>{{ gamePlay.yardLine }}</td>
              <td>{{ gamePlay.hash }}</td>
              <td>{{ gamePlay.playType }}</td>
              <td>{{ gamePlay.result }}</td>
              <td>{{ gamePlay.gnLs }}</td>
              <td>{{ gamePlay.penYards }}</td>
              <td>{{ gamePlay.penTeam }}</td>
              <td><div class="vertical">{{ gamePlay.kickYards }}</div></td>
              <td><div class="vertical">{{ gamePlay.returnYards }}</div></td>
              <td><div class="vertical">{{ gamePlay.rusher }}</div></td>
              <td><div class="vertical">{{ gamePlay.oppRusher }}</div></td>
              <td><div class="vertical">{{ gamePlay.passer }}</div></td>
              <td><div class="vertical">{{ gamePlay.oppPasser }}</div></td>
              <td><div class="vertical">{{ gamePlay.receiver }}</div></td>
              <td><div class="vertical">{{ gamePlay.oppReceiver }}</div></td>
              <td><div class="vertical">{{ gamePlay.tackler1 }}</div></td>
              <td><div class="vertical">{{ gamePlay.oppTackler1 }}</div></td>
              <td><div class="vertical">{{ gamePlay.tackler2 }}</div></td>
              <td><div class="vertical">{{ gamePlay.oppTackler2 }}</div></td>
              <td><div class="vertical">{{ gamePlay.battedDown }}</div></td>
              <td><div class="vertical">{{ gamePlay.oppBattedDown }}</div></td>
              <td><div class="vertical">{{ gamePlay.forcedFumbleBy }}</div></td>
              <td><div class="vertical">{{ gamePlay.oppForcedFumbleBy }}</div></td>
              <td><div class="vertical">{{ gamePlay.returner }}</div></td>
              <td><div class="vertical">{{ gamePlay.oppReturner }}</div></td>
              <td><div class="vertical">{{ gamePlay.kicker }}</div></td>
              <td><div class="vertical">{{ gamePlay.oppKicker }}</div></td>
              <td><div class="vertical">{{ gamePlay.recoveredBy }}</div></td>
              <td><div class="vertical">{{ gamePlay.oppRecoveredBy }}</div></td>
              <td><div class="vertical">{{ gamePlay.interceptedBy }}</div></td>
              <td><div class="vertical">{{ gamePlay.oppInterceptedBy }}</div></td>
            </tr>
          }
        </tbody>
      </table>
    </section>
  }
  <footer>
    <button mat-flat-button data-testid="backEditPlayList" (click)="back()">Back</button>
  </footer>
</div>
